import React, { Fragment, useState, useRef, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../../toast/SetToast";
import Toast from "../../toast/SetToast";
import { useFirestore } from "../../../../hook/useFirestore";
import { TechForm } from "./TechForm";

const roleList = [
  { role: "Record", status: false },
  { role: "Score", status: false },
];

const TechRegister = (props) => {
  const { addDocument } = useFirestore("sleeptechnicians");
  const [checked, setChecked] = useState(roleList);
  const inputRef = useRef({
    techId: "",
    name: "",
    fullname: "",
    email: "",
    tel: "",
    node: "",
    roles: [],
    certificate: "",
    status: "",
    accessToken: "",
    nickname: "",
    team: "",
  });

  const handleChange = (name) => (e) => {
    inputRef.current[name] = e.target.value;
  };

  const handleChecked = (e, idx) => {
    if (e.target.checked) {
      let o = Object.assign({}, checked[idx], {
        ...checked[idx],
        status: true,
      });
      const updateList = [
        ...checked.slice(0, idx),
        o,
        ...checked.slice(idx + 1),
      ];

      setChecked(updateList);
    } else {
      let o = Object.assign({}, checked[idx], {
        ...checked[idx],
        status: false,
      });
      const updateList = [
        ...checked.slice(0, idx),
        o,
        ...checked.slice(idx + 1),
      ];

      setChecked(updateList);
    }
  };

  const handleOnHideModal = () => {
    props.hide();
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      techId: inputRef.current.techId,
      name: inputRef.current.name,
      fullname: inputRef.current.fullname,
      email: inputRef.current.email,
      tel: inputRef.current.tel,
      node: inputRef.current.node,
      roles: checked,
      certificate: inputRef.current.certificate,
      status: inputRef.current.status,
      accessToken: inputRef.current.accessToken,
      nickname: inputRef.current.nickname,
      team: inputRef.current.team,
    };

    console.log(formData);

    addDocument(formData)
      .then(() => {
        notifyTopRight("บันทึกข้อมูลสำเร็จ");
      })
      .catch((err) => {
        notifyError("บันทึกข้อมูลผิดพลาด ", err);
      });

    props.hide();
  };

  return (
    <Fragment>
      <Toast />
      <Modal
        className="fade bd-example-modal-lg"
        show={props.show}
        onHide={handleOnHideModal}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Register Technician</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TechForm onChange={handleChange} onChecked={handleChecked} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
        <div className="d-flex justify-content-center mb-3">
          <Button className="sm" onClick={handleSubmit}>
            Save
          </Button>
          <Button
            className="sm ml-2"
            variant="light"
            onClick={handleOnHideModal}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </Fragment>
  );
};

export default TechRegister;
